import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { StoreService } from '../../core/store.service';
import { HttpService, EndWithSlash } from 'projects/lib-components/src/public_api';
import { BaseStage } from '../base-stage';
import { GenericData, Stage, StageYear, Catalog, StagesModel, SessionItem, eItem, Product, Address } from '../../shared';

@Component({
  // tslint:disable-next-line: component-selector
  selector: 'webstore-stages-list',
  templateUrl: './stages-list.component2.html',
  styleUrls: ['./stages-list.component2.css']
})

// tslint:disable-next-line: component-class-suffix
export class StagesListComponent2 extends BaseStage implements OnInit {

  public nbStage: number;
  public stages: GenericData<Stage>[] = [];
  public stagesFiltered: GenericData<Stage>[] = [];
  public yearList: StageYear[];
  public catalogueList: Catalog[];
  public addressList: Address[];

  constructor(
    public store: StoreService,
    protected http: HttpService,
    protected router: Router
  ) {
    super(store);
  }

  ngOnInit(): void {
    this.store.showSplash(true);
    const destUrl: string = `${EndWithSlash(this.store.AppParams.apiUrl)}api/stageslist/V2/`;
    const model: StagesModel = new StagesModel();
    model.Mode = 'INITDATALIST';
    this.http.postHttp<StagesModel>(destUrl, model).subscribe((data: StagesModel): void => {
      if (!data.HasError) {
        this.nbStage = data.StageList.length;
        if (this.nbStage === 0) {
          this.store.warning(this.store.getTrad('nostage'));
        } else {
          this.yearList = data.StageYearsList;
          this.catalogueList = data.CatalogueList;
          this.addressList = data.AddressList;

          this.stages = this.store.convertList<Stage>(data.StageList, 2);
          this.stagesFiltered = this.stages;

          const parentProduct: SessionItem|null = super.getSession(eItem.PRODUCT);
          if (parentProduct) {
            if (this.stages && parentProduct.code && parentProduct.code !== '') {
              this.stagesFiltered = super.filterStagesProd(this.stagesFiltered, parentProduct.code);
              super.removeSession(eItem.PRODUCT);
            }
          }
        }
        this.store.showSplash(false);
      }
    }, (error: any): void => {
      JSON.stringify(error);
    });
  }

  formatContent(cnt: string): string {
    return cnt.length > 250 ? `${cnt.substring(0, 250)} ... ` : cnt;
  }
  formatTooltip(cnt: string): string {
    return cnt.length > 250 ? cnt : '';
  }

  getCurrentStage(stage: Stage): void {
    super.setStage(stage);
    this.router.navigate([this.store.AppRoutes.STAGEDETAILS]);
  }

  getStagesByDate(year: number, month: number): void {
    this.stagesFiltered = super.filterStagesDate(this.stages, year, month);
  }

  getStagesByProduct(prod: Product): void {
    this.stagesFiltered = super.filterStagesProd(this.stages, prod.Code_PRO);
  }

  getStagesByAddresst(item: Address): void {
    this.stagesFiltered = super.filterStagesAddress(this.stages, item);
  }

  getAllSession(): void {
    this.stagesFiltered = this.stages;
  }
}
